export class AccessPointEvents {
  static accessPointChangeNotification = 'accessPointChangeNotification';
  static doorRefreshNotification: 'doorRefreshNotification';
  static stopMessenger = 'stopMessenger';
};
